import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import StringGroupInfo from '@/views/Language/components/stringGroupInfo/stringGroupInfo.vue'

import StringGroupModel from '@/views/Language/models/stringGroup'
import TagModel from '@/views/Language/models/tag'
@Component({
    components: { StringGroupInfo },
    name: 'string-group',
})
export default class StringGroup extends Mixins<MixinInterface>() {
    @VModel() stringGroup!: StringGroupModel
    @Prop({ required: true }) stringGroups!: Array<StringGroupModel>

    get tags(): Array<TagModel> {
        return this.$store.getters.tags
    }

    get token() {
        return this.$route.params.token
    }

    get activeLanguages() {
        return this.$store.getters.activeLanguages
    }

    get searchTags() {
        return this.$store.getters.stringGroupTags
    }

    get matchSearchTags() {
        return this.searchTags.length > 0
            ? this.searchTags.findIndex((tag) => this.stringGroup.hasTag(tag)) > -1
            : true
    }

    // DELETE
    deleting = false
    async toggleDelete() {
        this.deleting = true
        await this.stringGroup.delete()
        this.deleting = false
    }
}
